<template lang="pug">
  .col-24.initBackgroundImage.flexD.alignItemsCenter.justifyCenter.l-padding-top-6em.l-padding-bottom-6em(:style="{backgroundImage:'url('+ img.bg +')'}")
    .col-12.minWidth700.m-minWidthAuto.m-width-90
      .font-title {{ title }}
      .col-24.flexD.flexDirectionRow.flexWrap.justifySpaceBetween.l-margin-top-2em
        .col-7.l-margin-bottom-2em(v-for="(item, index) in teams" :key="index")
          .col-24.initBackgroundImage(:style="{backgroundImage:'url('+ item.img +')', paddingTop: '40%', backgroundSize: 'contain'}")

</template>

<script>
  export default {
    name: 'teamWork',
    props: ['content'],
    data(){
      return{
        title: this.$t('team_work.title'),
        teams: [
          { img: require('@/assets/img/logo/logo_wellve.png')},
          { img: require('@/assets/img/logo/logo_pressalit.png')},
          { img: require('@/assets/img/logo/logo_wibo.png')},
          { img: require('@/assets/img/logo/logo_dietz.png')},
          { img: require('@/assets/img/logo/logo_whd.png')},
          { img: require('@/assets/img/logo/logo_stigler.png')},
        ],
        img: {
          bg: require('@/assets/img/banner_teamWork.jpg')
        }
      }
    },
    computed: {},
    methods:{},
    created(){}
  }
</script>
